import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

/**
 * Fire-and-forget haptics. No-op on the web, and a device without a taptic engine simply throws,
 * which is not worth surfacing to the caller.
 */
const impact = (style: ImpactStyle) => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  Haptics.impact({ style }).catch(() => {
    // No haptics on this device or simulator.
  });
};

const useHaptics = () => ({
  light: () => impact(ImpactStyle.Light),
  medium: () => impact(ImpactStyle.Medium),
});

export default useHaptics;
